import { useTranslation } from 'react-i18next';
import { useTheme, List, ListItem, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { locations } from 'services/routes/locations';

const MobileSideBarAccount = (): React.ReactElement => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();

  const isPageSelected = (page: string) => page === location.pathname;

  return (
    <List
      sx={{
        display: 'flex',
        gap: theme.spacing(3),
        justifyContent: 'space-between',
        alignItems: 'center',
        px: theme.spacing(1.8),
      }}
    >
      <ListItem
        disablePadding
        component={Link}
        data-testid="overviewButton"
        to={locations.account.overview.pathname}
        selected={isPageSelected(locations.account.overview.pathname)}
        sx={{
          width: 'auto',
          color: theme.palette.grey[400],
          '&.Mui-selected': {
            color: theme.palette.grey[50],
            background: theme.palette.grey[900],
          },
        }}
      >
        <ListItemText
          data-testid="overviewText"
          primary={t('account:sideBar:account')}
        />
      </ListItem>
      <ListItem
        disablePadding
        component={Link}
        data-testid="subscriptionButton"
        to={locations.account.subscription.pathname}
        selected={isPageSelected(locations.account.subscription.pathname)}
        sx={{
          width: 'auto',
          color: theme.palette.grey[400],
          '&.Mui-selected': {
            color: theme.palette.grey[50],
            background: theme.palette.grey[900],
          },
        }}
      >
        <ListItemText
          data-testid="subscriptionText"
          primary={t('account:sideBar:subscription')}
        />
      </ListItem>
      <ListItem
        disablePadding
        component={Link}
        data-testid="youtubeButton"
        to={locations.account.youTube.pathname}
        selected={isPageSelected(locations.account.youTube.pathname)}
        sx={{
          width: 'auto',
          color: theme.palette.grey[400],
          '&.Mui-selected': {
            color: theme.palette.grey[50],
            background: theme.palette.grey[900],
          },
        }}
      >
        <ListItemText
          data-testid="youTubeText"
          primary={t('account:sideBar:youTube')}
        />
      </ListItem>
    </List>
  );
};

export default MobileSideBarAccount;
